module.exports = __webpack_public_path__ + "img/@contact.08e11fa7.jpg";